import { render, staticRenderFns } from "./ColorSwatch.vue?vue&type=template&id=73c57ee0&"
import script from "./ColorSwatch.vue?vue&type=script&lang=js&"
export * from "./ColorSwatch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports